import { useMemo } from 'react';
import { DEVICE_CONNECTION_STATE } from '../../constants/common';

export interface DeviceActivityStateProps {
  active: boolean;
}

export const DeviceActivityState = ({ active }: DeviceActivityStateProps) => {
  const text = useMemo(() => {
    if (active) {
      return DEVICE_CONNECTION_STATE.CONNECTED;
    }
    return DEVICE_CONNECTION_STATE.DISCONNECTED;
  }, [active]);

  const textStyles = useMemo(() => {
    if (active) {
      return 'bg-success text-success';
    }
    return 'bg-danger text-danger';
  }, [active]);

  return (
    <span className="flex w-full items-center justify-start">
      <span className={`inline-flex rounded bg-opacity-10 px-2 py-1 text-xs font-medium ${textStyles}`}>{text}</span>
    </span>
  );
};
